export const SERVICE_ENVIRONMENT = 'SERVICE_ENVIRONMENT';
export const GOOGLE_TAG_MANAGER_ID = 'googleTagManagerId';
